/* Italycharm LP — live cart drawer.
   The #lp-cdraw drawer shows the STORE'S REAL cart by fetching the full /cart
   page and injecting its OWN rendered section elements (…__cart-items,
   …__icb_cart_upsell, …__cart-footer) into the existing shell — the markup +
   classes are the theme's own and cannot drift from hand-copied HTML.
   Loaded with defer AFTER assets/lp.js; overrides window.LP.openDrawer +
   window.ICB_refreshCart, leaves closeDrawer / stickyGo / checkout intact.

   Round 9  — NATURAL SCROLL: cart-items + upsell + real cart footer all stack
             inside the one scroll body (#lp-cbody) — nothing pinned.
   Round 12 — OPTIMISTIC UI: qty +/-, remove and upsell-add update the visible
             DOM INSTANTLY (number / row / line total / subtotal), then POST in
             the background and reconcile via a full /cart re-parse (which also
             syncs gift lines).
   Round 15 — Gift lines are FULLY EDITABLE like normal products (stepper +
             remove shown); native BXGY prices the entitled qty $0 and charges
             extras. Product-detail links inside the drawer do NOT navigate
             (customers stay in the LP). A session gift-hold countdown is pinned
             at the top of the drawer; the sticky bar shows a loading spinner
             while the cart is fetching.
   Round 20 — LIGHT reconcile (kills add/remove lag) + duplicate-line self-heal +
             presentment-correct "You saved" summary line:
             • reconcile fetches /cart.js FIRST (cheap JSON). It re-injects the
               full /cart HTML ONLY when the set of line keys OR the total discount
               changed (a line added/removed, or a gift toggled). Pure quantity /
               price edits patch the existing DOM in place → no HTML fetch, no
               flicker, no lag.
             • dedupeCharms() merges any two cart lines of the SAME charm variant
               into one line (gift + base lines untouched), so a charm can never
               show up duplicated no matter how the reconcile passes interleave.
             • renderSavings() adds a "You saved" row to the drawer summary, in the
               active presentment currency. */
(function () {
  'use strict';

  var liveMode = false;
  var refreshing = false, pending = false;
  var lastDiscount = -1; // last rendered cart.total_discount — a change forces a re-inject
  // Round 19 — cart-mutation queue + smart reconcile (kills add/remove jitter + lost deletes):
  // change.js calls run serialized on mutChain; a single debounced reconcile fires only once
  // no mutation is in flight, preserves scroll, and skips the re-inject entirely when the
  // optimistic DOM already equals the server cart.
  var mutChain = Promise.resolve();
  var inflightMut = 0;
  var reconcileTimer = null;

  function $(id) { return document.getElementById(id); }
  function drawerOpen() { var d = $('lp-cdraw'); return !!(d && d.classList.contains('on')); }

  /* ---- money helpers (optimistic maths; the background re-parse is authoritative) ---- */
  function numOf(str) { var m = String(str == null ? '' : str).match(/[0-9][0-9,]*(?:\.[0-9]+)?/); return m ? parseFloat(m[0].replace(/,/g, '')) : NaN; }
  function setMoneyEl(el, value) { if (!el) return; var t = el.textContent, m = t.match(/[0-9][0-9,]*(?:\.[0-9]+)?/); var v = Math.max(0, value).toFixed(2); el.textContent = m ? t.replace(m[0], v) : '$' + v; }
  function bumpMoneyEl(el, delta) { if (!el) return; var cur = numOf(el.textContent); if (isNaN(cur)) return; setMoneyEl(el, Math.max(0, cur + delta)); }
  function bumpTotals(delta) {
    var body = $('lp-cbody'); if (!body || !delta) return;
    var sub = body.querySelector('.icb-sumbox .icb-sumrow span:last-child'); bumpMoneyEl(sub, delta);
    var tot = body.querySelector('.icb-sumbox .icb-sumtotal span:last-child'); bumpMoneyEl(tot, delta);
  }

  /* ---- fetch + parse the full /cart page (r.ok check + one network retry) ---- */
  function getCartDoc(retried) {
    return fetch('/cart', { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function (err) {
        if (retried) throw err;
        return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return getCartDoc(true); });
      });
  }

  function getCartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  /* ---- POST mutation helper ---- */
  function mutate(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('HTTP ' + r.status + ' ' + t); });
      return r.json();
    });
  }

  function dispatchRefresh() { try { document.dispatchEvent(new Event('cart:refresh')); } catch (e) {} }
  function setStickyLoading(on) { var s = $('lp-sticky'); if (s) s.classList.toggle('lp-loading', !!on); }

  /* ---- Build the three live containers inside the existing shell (one scroll flow) ---- */
  function ensureShell() {
    var body = $('lp-cbody');
    if (!body) return null;
    // #lp-cfoot holds the server-rendered native {% form 'cart' %} checkout + express
    // buttons (accelerated-checkout hydrates because it is on the page at load) — leave it intact.
    if (!$('lp-live-items') || !$('lp-live-upsell') || !$('lp-live-footer')) {
      body.innerHTML = '<div id="lp-live-items"></div><div id="lp-live-upsell"></div><div id="lp-live-footer"></div>';
    }
    return { items: $('lp-live-items'), upsell: $('lp-live-upsell'), footer: $('lp-live-footer') };
  }

  /* ---- instant loading state (shown synchronously on open) ---- */
  function showLoading() {
    var c = ensureShell(); if (!c) return;
    if (c.items.querySelector('.cart-item, .cart__warnings, [id*="__cart-items"]')) return; // already populated
    c.items.innerHTML =
      '<div class="lp-live-loading" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:56px 0;color:#582239">' +
      '<span class="lp-live-spin" style="width:26px;height:26px;border:3px solid rgba(88,34,57,.2);border-top-color:#582239;border-radius:50%;display:inline-block;animation:lp-live-spin .8s linear infinite"></span>' +
      '<span style="font-size:13px;letter-spacing:.02em">Loading your bag…</span></div>';
    c.footer.innerHTML = '';
  }

  function updateBadge(cart) {
    var apply = function (c) { if (!c) return; var b = $('lp-cbadge'); if (b) b.textContent = c.item_count > 0 ? c.item_count : 0; };
    if (cart) { apply(cart); return; }
    getCartJson().then(apply);
  }

  /* ---- tag gift lines (properties._auto_gift) with .lp-gift-line (kept for any
     styling hooks). Round 15: gift lines are fully editable, so no interaction is
     blocked here — the tag is purely informational. ---- */
  function markGiftLines(cart) {
    var body = $('lp-cbody'); if (!body || !cart || !cart.items) return;
    var gift = {};
    cart.items.forEach(function (it) { var p = it.properties || {}; if (p._auto_gift) gift[it.key] = 1; });
    body.querySelectorAll('.cart-item[data-key]').forEach(function (row) {
      row.classList.toggle('lp-gift-line', !!gift[row.getAttribute('data-key')]);
    });
  }

  /* ---- reconcile helpers (Round 19) ---- */
  function scrollEl() { return document.querySelector('#lp-cdraw .lp-res'); }
  // True when the visible rows already equal the server cart (same keys + quantities) — then we
  // can skip the re-inject and avoid the DOM-replace "jump". Empty cart returns false so the
  // theme's empty-cart markup gets rendered.
  function domMatchesCart(cart) {
    var body = $('lp-cbody'); if (!body || !cart || !cart.items) return false;
    var srv = {}, srvCount = 0;
    cart.items.forEach(function (it) { srv[it.key] = it.quantity; srvCount++; });
    if (!srvCount) return false;
    var rows = body.querySelectorAll('.cart-item[data-key]');
    if (rows.length !== srvCount) return false;
    for (var i = 0; i < rows.length; i++) {
      var k = rows[i].getAttribute('data-key');
      if (!(k in srv)) return false;
      var input = rows[i].querySelector('.quantity__input');
      var q = input ? parseInt(input.value, 10) : NaN;
      if (q !== srv[k]) return false;
    }
    return true;
  }
  function updateSummaryFromCart(cart) {
    var body = $('lp-cbody'); if (!body || !cart) return;
    var sub = body.querySelector('.icb-sumbox .icb-sumrow span:last-child'); if (sub) setMoneyEl(sub, cart.items_subtotal_price / 100);
    var tot = body.querySelector('.icb-sumbox .icb-sumtotal span:last-child'); if (tot) setMoneyEl(tot, cart.total_price / 100);
  }

  /* ---- Round 20: presentment-correct "You saved" row in the drawer summary ----
     cart.js money is in the SHOP BASE currency, but the injected /cart HTML shows the
     customer's active PRESENTMENT currency (e.g. the owner previewing in VND). We derive
     the presentment rate from displayed-subtotal ÷ base-subtotal so the number matches
     whatever the customer sees, and format it with Intl in the active currency. */
  // The DISPLAYED currency is whatever the injected /cart HTML renders (Markets presentment),
  // NOT window.Shopify.currency.active (that is the shop BASE currency — reports USD even when the
  // customer sees ₫). So detect it straight from a money string in the summary.
  function detectCurrency(box) {
    var el = box.querySelector('.icb-sumrow .money') || box.querySelector('.icb-sumrow span:last-child');
    var t = el ? el.textContent : '';
    if (/[₫đ]|VND/i.test(t)) return 'VND';
    if (/€|EUR/i.test(t)) return 'EUR';
    if (/£|GBP/i.test(t)) return 'GBP';
    if (/¥|JPY|CNY/i.test(t)) return 'JPY';
    if (/\$|USD/.test(t)) return 'USD';
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; } catch (e) { return 'USD'; }
  }
  function curDecimals(cc) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).resolvedOptions().maximumFractionDigits; } catch (e) { return 2; } }
  function parseMoneyStr(str, dec) { var digits = String(str == null ? '' : str).replace(/[^\d]/g, ''); if (!digits) return NaN; return dec > 0 ? parseInt(digits, 10) / Math.pow(10, dec) : parseInt(digits, 10); }
  function fmtMoney(value, cc) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).format(value); } catch (e) { return '$' + (Math.round(value * 100) / 100).toFixed(2); } }
  function renderSavings(cart) {
    var body = $('lp-cbody'); if (!body || !cart) return;
    var box = body.querySelector('.icb-sumbox'); if (!box) return;
    var cc = detectCurrency(box), dec = curDecimals(cc);
    var subEl = box.querySelector('.icb-sumrow:not(.icb-sumtotal) .money') || box.querySelector('.icb-sumrow:not(.icb-sumtotal) span:last-child');
    var dispSub = subEl ? parseMoneyStr(subEl.textContent, dec) : NaN;
    var baseSub = cart.items_subtotal_price || 0; // cart.js money (base currency cents)
    // Unit-robust: saved_displayed = total_discount × (displayed subtotal ÷ cart.js subtotal). This
    // converts the applied-discount total into the DISPLAYED currency whether cart.js is base or presentment.
    var saved = (!isNaN(dispSub) && dispSub > 0 && baseSub > 0)
      ? ((cart.total_discount || 0) * dispSub / baseSub)
      : ((cart.total_discount || 0) / 100);
    var row = box.querySelector('.lp-saved-row');
    if (!(saved > 0.001)) { if (row && row.parentNode) row.parentNode.removeChild(row); return; }
    var inner = '<span>You saved</span><span class="lp-saved-amt">−' + fmtMoney(saved, cc) + '</span>';
    if (!row) {
      row = document.createElement('div');
      row.className = 'icb-sumrow lp-saved-row';
      row.innerHTML = inner;
      var totalRow = box.querySelector('.icb-sumtotal');
      if (totalRow && totalRow.parentNode === box) box.insertBefore(row, totalRow); else box.appendChild(row);
    } else { row.innerHTML = inner; }
  }

  /* ---- Round 20: self-heal duplicate charm lines. Two cart lines of the SAME charm
     variant (any properties) are consolidated into ONE line (sum the quantities onto the
     first line, remove the rest). Gift (_auto_gift) and base (_role:'base') lines are left
     alone. Runs serialized on mutChain so it never races a user mutation, and only re-fetches
     when it actually merged something. This makes a duplicated charm impossible to persist,
     regardless of how the picker-add / gift-tier / live-cart reconcile passes interleave. ---- */
  function dedupeCharms(cart) {
    if (!cart || !cart.items) return Promise.resolve(null);
    var byVar = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._auto_gift || p._role === 'base') return;
      var v = it.variant_id; if (v == null) return;
      (byVar[v] = byVar[v] || []).push(it);
    });
    var changes = [];
    Object.keys(byVar).forEach(function (v) {
      var lines = byVar[v]; if (lines.length < 2) return;
      var total = 0; lines.forEach(function (l) { total += l.quantity; });
      changes.push({ id: lines[0].key, quantity: total });        // sum everything onto the first line
      for (var i = 1; i < lines.length; i++) changes.push({ id: lines[i].key, quantity: 0 }); // drop the rest
    });
    if (!changes.length) return Promise.resolve(null);
    inflightMut++;
    mutChain = mutChain.then(function () {
      var chain = Promise.resolve();
      changes.forEach(function (ch) { chain = chain.then(function () { return mutate('/cart/change.js', ch).catch(function () {}); }); });
      return chain;
    });
    return mutChain.then(function () { inflightMut--; return getCartJson(); }, function () { inflightMut--; return null; });
  }

  /* ---- inject / reconcile the real cart sections into the drawer (full /cart page). ---- */
  function injectCartDoc(doc, cart, sc, savedScroll) {
    var c = ensureShell(); if (!c || !doc) return;
    var it = doc.querySelector('[id*="__cart-items"]');
    var up = doc.querySelector('[id*="__icb_cart_upsell"]');
    var ft = doc.querySelector('[id*="__cart-footer"]');
    if (it) c.items.innerHTML = it.outerHTML;
    c.upsell.innerHTML = up ? up.outerHTML : '';
    if (ft) c.footer.innerHTML = ft.outerHTML;
    if (cart) { updateBadge(cart); markGiftLines(cart); renderSavings(cart); lastDiscount = cart.total_discount || 0; }
    else { updateBadge(); }
    if (sc) sc.scrollTop = savedScroll; // preserve scroll → no visual jump
  }

  /* Round 20 — LIGHT reconcile. /cart.js first; self-heal duplicates; re-inject the HTML ONLY
     when the line-key set OR the total discount changed. Pure quantity/price edits (same keys,
     same discount) patch in place → no HTML fetch, no flicker, no lag. */
  function refreshLiveCart() {
    if (!drawerOpen()) return Promise.resolve();
    if (refreshing) { pending = true; return Promise.resolve(); } // in-flight guard: coalesce, never stack
    refreshing = true; setStickyLoading(true);
    var sc = scrollEl(); var savedScroll = sc ? sc.scrollTop : 0;
    return getCartJson().then(function (cart) {
      var c = ensureShell(); if (!c) return;
      if (!cart) { return getCartDoc().then(function (doc) { injectCartDoc(doc, null, sc, savedScroll); }); }
      return dedupeCharms(cart).then(function (fresh) {
        if (fresh) cart = fresh; // duplicates were merged → reconcile against the refreshed cart
        var discount = cart.total_discount || 0;
        if (domMatchesCart(cart) && discount === lastDiscount) {
          // qty/price only — DOM already correct from the optimistic update; just true up gifts + savings.
          renderSavings(cart); markGiftLines(cart); updateBadge(cart);
          return;
        }
        return getCartDoc().then(function (doc) { injectCartDoc(doc, cart, sc, savedScroll); });
      });
    }).catch(function (e) {
      console.warn('[LP live cart] refresh failed', e);
    }).then(function () {
      refreshing = false; setStickyLoading(false);
      if (pending) { pending = false; return refreshLiveCart(); }
    });
  }

  // Debounced single reconcile — runs only once no cart mutation is in flight, so a burst of
  // rapid +/- / remove clicks never re-injects mid-interaction.
  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      if (inflightMut > 0) { scheduleReconcile(); return; }
      refreshLiveCart();
    }, 220);
  }

  function openLive() {
    var d = $('lp-cdraw'); if (!d) return;
    liveMode = true;
    d.style.display = 'flex';
    d.classList.add('on');
    ensureShell();
    showLoading();      // appears instantly, before the fetch
    startGiftTimer();   // (re)show the session gift-hold countdown
    refreshLiveCart();  // fills in ~1s
  }

  /* ---- cart mutations (OPTIMISTIC: reflect the action in the DOM immediately,
     then POST + full re-parse in the background to reconcile exact totals + gifts) ---- */
  function keyOf(row) {
    if (!row || !row.getAttribute) return null;
    var k = row.getAttribute('data-key');
    if (k) return k;
    var idx = row.getAttribute('data-index');
    return idx ? parseInt(idx, 10) : null;
  }

  function bgChange(id, qty) {
    if (id == null) return;
    liveMode = true; setStickyLoading(true);
    inflightMut++;
    var payload = typeof id === 'number' ? { line: id, quantity: qty } : { id: id, quantity: qty };
    // Serialize on mutChain so rapid clicks on the same line resolve to a deterministic final
    // quantity (last-write-wins), and remove (qty 0 by line key) always persists.
    mutChain = mutChain.then(function () {
      return mutate('/cart/change.js', payload).then(function () { dispatchRefresh(); }, function (e) { console.warn('[LP live cart] change failed', e); });
    }).then(function () { inflightMut--; scheduleReconcile(); });
  }

  // Optimistic quantity change driven from a DOM row.
  function optimisticQtyFromRow(row, newQty) {
    if (!row) return;
    var input = row.querySelector('.quantity__input');
    var oldQty = input ? (parseInt(input.value, 10) || 0) : 0;
    if (newQty < 0) newQty = 0;
    var lineEl = row.querySelector('.cart-item__totals .price--end') || row.querySelector('.price--end');
    var curLine = lineEl ? numOf(lineEl.textContent) : NaN;
    var unit = (!isNaN(curLine) && oldQty > 0) ? curLine / oldQty : NaN;
    if (newQty === 0) {
      if (!isNaN(curLine)) bumpTotals(-curLine);
      row.parentNode && row.parentNode.removeChild(row);
    } else {
      if (input) input.value = newQty;
      if (!isNaN(unit)) {
        var newLine = unit * newQty;
        row.querySelectorAll('.price--end').forEach(function (e) { setMoneyEl(e, newLine); });
        if (!isNaN(curLine)) bumpTotals(newLine - curLine);
      }
    }
    bgChange(keyOf(row), newQty);
  }

  function addVariant(vid, btn) {
    liveMode = true; setStickyLoading(true);
    if (btn) { btn.disabled = true; btn.textContent = 'Added ✓'; btn.classList.add('lp-added'); }
    var b = $('lp-cbadge'); if (b) { var n = parseInt(b.textContent, 10) || 0; b.textContent = n + 1; } // optimistic badge
    inflightMut++;
    mutChain = mutChain.then(function () {
      return mutate('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }).then(function () { dispatchRefresh(); }, function (e) {
        console.warn('[LP live cart] add failed', e);
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; btn.classList.remove('lp-added'); }
      });
    }).then(function () { inflightMut--; scheduleReconcile(); });
  }

  /* ---- delegated interactions (document-level, survive re-injection) ---- */
  function onClick(e) {
    if (!e.target.closest || !e.target.closest('#lp-cdraw')) return;

    // Checkout (real footer submit button / link) -> /checkout
    if (e.target.closest('#checkout, [name="checkout"], .cart__checkout-button')) {
      e.preventDefault();
      if (window.LP && typeof window.LP.checkout === 'function') window.LP.checkout();
      else window.location.href = '/checkout';
      return;
    }
    // Discount code apply (the footer's inline script does not run on injected HTML)
    if (e.target.closest('#icbDcodeBtn')) {
      e.preventDefault();
      var inp = $('icbDcode'); var v = inp && inp.value ? inp.value.trim() : '';
      if (v) window.location.href = '/discount/' + encodeURIComponent(v) + '?redirect=%2Fcheckout';
      return;
    }
    // Remove line
    var rm = e.target.closest('cart-remove-button');
    if (rm) {
      e.preventDefault();
      optimisticQtyFromRow(e.target.closest('[data-key], .cart-item'), 0);
      return;
    }
    // Upsell add
    var add = e.target.closest('.icb-cu-add');
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute('data-vid');
      if (vid) addVariant(vid, add);
      return;
    }
    // Qty minus / plus
    var qb = e.target.closest('.quantity__button');
    if (qb) {
      e.preventDefault();
      var qrow = qb.closest('[data-key], .cart-item');
      var input = qrow && qrow.querySelector('.quantity__input');
      if (!input) return;
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      var cur = parseInt(input.value, 10) || 0;
      var nq = qb.getAttribute('name') === 'minus' ? cur - step : cur + step;
      if (nq < 0) nq = 0;
      optimisticQtyFromRow(qrow, nq);
      return;
    }
    // Owner decision: keep customers in the LP. Clicking a charm's NAME opens a lightweight
    // description-only popup (title + product.description) instead of navigating to the PDP.
    var nameLink = e.target.closest('a.cart-item__name');
    if (nameLink) {
      e.preventDefault();
      openCharmDesc(nameLink.getAttribute('href'));
      return;
    }
    // Image link + any other product link: still no navigation (stay in the LP), no popup.
    if (e.target.closest('a.cart-item__link, a[href*="/products/"]')) {
      e.preventDefault();
      return;
    }
  }

  /* ---- Charm DESCRIPTION popup (description only — no buttons, no add-to-cart, no link out).
     Layout: an image carousel of ALL the product's images on top, then the title, then the
     product.description HTML, in a compact centered modal layered over the drawer. It only
     opens when the product actually HAS description text; a product with no description does
     nothing (Item 2). ---- */
  function handleFromUrl(url) { var m = String(url || '').match(/\/products\/([a-z0-9][a-z0-9-]*)/i); return m ? m[1] : ''; }
  function descEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ensureDescModal() {
    var ov = $('lp-descm'); if (ov) return ov;
    ov = document.createElement('div');
    ov.id = 'lp-descm'; ov.className = 'lp-descm';
    ov.innerHTML = '<div class="lp-descm-card"></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('.lp-descm-x')) { ov.classList.remove('on'); return; }
      var nav = e.target.closest('.lp-descm-nav'); if (!nav) return;
      var car = ov.querySelector('.lp-descm-carousel'); if (!car) return;
      var slides = car.querySelectorAll('.lp-descm-slide'); var nn = slides.length; if (!nn) return;
      var idx = (parseInt(car.getAttribute('data-idx'), 10) || 0) + (nav.classList.contains('lp-descm-next') ? 1 : -1);
      if (idx < 0) idx = nn - 1; if (idx >= nn) idx = 0;
      car.setAttribute('data-idx', idx);
      var track = car.querySelector('.lp-descm-track'); if (track) track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      var cur = car.querySelector('.lp-descm-cur'); if (cur) cur.textContent = idx + 1;
    });
    return ov;
  }
  function openCharmDesc(href) {
    var handle = handleFromUrl(href); if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) {
        // Item 2: real description text required (ignore empty tags / whitespace / &nbsp;).
        var probe = document.createElement('div'); probe.innerHTML = p.description || '';
        var txt = (probe.textContent || '').replace(/ /g, ' ').trim();
        if (!txt) return; // no description → no popup
        var imgs = (p.images || []).filter(Boolean);
        if (!imgs.length && p.featured_image) imgs = [p.featured_image];
        var multi = imgs.length > 1;
        var car = imgs.length
          ? '<div class="lp-descm-carousel" data-idx="0"><div class="lp-descm-viewport"><div class="lp-descm-track">' +
              imgs.map(function (u) { return '<div class="lp-descm-slide"><img src="' + descEsc(u) + '" alt="" loading="lazy"></div>'; }).join('') +
              '</div></div>' +
              (multi ? '<button type="button" class="lp-descm-nav lp-descm-prev" aria-label="Previous">‹</button><button type="button" class="lp-descm-nav lp-descm-next" aria-label="Next">›</button><div class="lp-descm-count"><span class="lp-descm-cur">1</span> / ' + imgs.length + '</div>' : '') +
            '</div>'
          : '';
        var ov = ensureDescModal();
        ov.querySelector('.lp-descm-card').innerHTML =
          '<button type="button" class="lp-descm-x" aria-label="Close">✕</button>' +
          car +
          '<h3 class="lp-descm-title">' + descEsc(p.title || '') + '</h3>' +
          '<div class="lp-descm-body">' + (p.description || '') + '</div>';
        ov.classList.add('on');
      })
      .catch(function () { /* silent — no popup on error */ });
  }

  function onChange(e) {
    if (!e.target.closest || !e.target.closest('#lp-cdraw')) return;
    var input = e.target.closest('.quantity__input');
    if (!input) return;
    var row = input.closest('[data-key], .cart-item');
    var nq = parseInt(input.value, 10);
    if (isNaN(nq) || nq < 0) nq = 0;
    optimisticQtyFromRow(row, nq);
  }

  // Intercept the header cart button so lp.js's OLD delegated openDrawer (and
  // the button's inline onclick) do not also fire and render the old drawer.
  function onCaptureClick(e) {
    if (e.target.closest && e.target.closest('[data-lp-open-drawer]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openLive();
    }
  }

  // Self-heal: if any old lp.js render clobbers our containers while the drawer
  // is open, rebuild the live cart. Gated by liveMode.
  function startObserver() {
    var body = $('lp-cbody'), foot = $('lp-cfoot');
    if (!body || typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function () {
      if (!liveMode || !drawerOpen()) return;
      if (!$('lp-live-items') || !$('lp-live-footer')) { showLoading(); refreshLiveCart(); }
    });
    obs.observe(body, { childList: true });
    if (foot) obs.observe(foot, { childList: true });
  }

  function installOverrides() {
    window.LP = window.LP || {};
    window.LP.openDrawer = openLive;
    window.ICB_refreshCart = function () {
      liveMode = true;
      refreshLiveCart();
      clearTimeout(window.__lpLiveReassert);
      window.__lpLiveReassert = setTimeout(function () { if (drawerOpen()) refreshLiveCart(); }, 1500);
      return Promise.resolve();
    };
  }

  /* ---- Session gift-hold countdown pinned at the top of the drawer ----
     Editable label + minutes from the picker config (window.LP_CONFIG.giftHold).
     Session-scoped (sessionStorage) so it resets per session; never blocks checkout. */
  var giftTimerInt = null;
  function giftHoldCfg() {
    var g = (window.LP_CONFIG && window.LP_CONFIG.giftHold) || {};
    var mins = parseInt(g.minutes, 10); if (isNaN(mins) || mins <= 0) mins = 30;
    return { label: g.label || '🎁 Your free gifts are reserved for', minutes: mins };
  }
  function ensureGiftTimerEl() {
    if ($('lp-ctimer')) return $('lp-ctimer');
    var sheet = document.querySelector('#lp-cdraw .lp-sheet');
    var res = document.querySelector('#lp-cdraw .lp-res');
    if (!sheet || !res) return null;
    var el = document.createElement('div');
    el.className = 'lp-ctimer'; el.id = 'lp-ctimer';
    el.innerHTML = '<span class="lp-ctimer-label"></span> <span class="lp-ctimer-clock"></span>';
    // Owner decision: the countdown lives at the BOTTOM of the cart (below the
    // discount-code field, which is inside .lp-res), above the checkout footer —
    // NOT pinned to the top and NOT stuck to the checkout button.
    var foot = document.querySelector('#lp-cdraw .lp-foot');
    if (foot && foot.parentElement === sheet) sheet.insertBefore(el, foot);
    else sheet.appendChild(el);
    return el;
  }
  function giftDeadline(mins) {
    var key = 'lpGiftHoldDeadline';
    var v = 0; try { v = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!v || v < Date.now()) { v = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(v)); } catch (e) {} }
    return v;
  }
  function startGiftTimer() {
    var el = ensureGiftTimerEl(); if (!el) return;
    var cfg = giftHoldCfg();
    var lbl = el.querySelector('.lp-ctimer-label'); if (lbl) lbl.textContent = cfg.label;
    var clock = el.querySelector('.lp-ctimer-clock');
    var deadline = giftDeadline(cfg.minutes);
    function tick() {
      var r = Math.max(0, deadline - Date.now());
      var m = Math.floor(r / 60000), s = Math.floor((r % 60000) / 1000);
      if (clock) clock.textContent = m + ':' + String(s).padStart(2, '0');
      if (r <= 0 && giftTimerInt) { clearInterval(giftTimerInt); giftTimerInt = null; }
    }
    tick();
    if (giftTimerInt) clearInterval(giftTimerInt);
    giftTimerInt = setInterval(tick, 1000);
  }

  function injectSpinnerKeyframes() {
    if ($('lp-live-style')) return;
    var s = document.createElement('style');
    s.id = 'lp-live-style';
    s.textContent = '@keyframes lp-live-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }

  function boot() {
    injectSpinnerKeyframes();
    installOverrides();
    startObserver();
    try { ensureGiftTimerEl(); } catch (e) {}
    document.addEventListener('click', onCaptureClick, true);
    document.addEventListener('click', onClick, false);
    document.addEventListener('change', onChange, false);
  }

  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
